import { Component } from "react";
import Box from '@mui/material/Box';
import ProfileHeader from "../../../components/ProfileHeader";
import { useParams, useNavigate, NavigateFunction } from "react-router-dom";
import { Trans } from 'react-i18next';
import DocumentIcons from "./DocumentIcons";
import Button from '@mui/material/Button';
import MainSection from "./MainSection";
import UnitDetailContext from "./UnitDetailContext";
import UnitsApi from "../../../api/UnitsApi";
import DocumentTypesApi from "../../../api/DocumentTypesApi";
import PolicyDetailDialog from "./policyDetailDialog";
import moment from 'moment';
import { HOST } from "../../../api/config/Constants";
import { getSessionStorage } from "../../../utils/StorageUtil";
import { TOKEN_SO_KEY } from "../../../utils/accountUtils";
import ProfileBottomNav from "../../../components/ProfileBottomNav";
import  { FULL_MENU } from '../../../api/config/Constants'

type Props = {
  params?: {domain: string},
  navigate?: NavigateFunction
}

type State = {
  refresh: boolean,
}

export const getDocumentName = (doc: any, contextDocumentTypes: any[], domain: string) => {
  const currentDate = moment().format('DDMMYYYY');
  const documentTypes = contextDocumentTypes.find(d => d.id === doc?.documentType.id);
  let appendExt = "jpeg";
  if (doc.fileContentType === "application/pdf") appendExt = "pdf";
  const subtype=documentTypes?.typeDoc?.name != documentTypes?.subtypeDoc?.name ? documentTypes?.subtypeDoc?.name + '-'   :''; 
  return documentTypes?.typeDoc?.name + '-'+subtype+ domain.toLocaleUpperCase() + '-' + + currentDate + '.' + appendExt;
}

function getLastDocuments(unitDetail: any): any {
  const lastDocuments: any = {};

  unitDetail.documents.forEach((doc: any) => {
    const docTypeStatus = `${doc.documentType.id}-${doc.status}`;

    if (!lastDocuments[docTypeStatus]) {
      lastDocuments[docTypeStatus] = doc;
    } else {
      const lastDoc = lastDocuments[docTypeStatus];
      const lastDueDate = new Date(lastDoc.dueDate);
      const currDueDate = new Date(doc.dueDate);

      if (currDueDate > lastDueDate) {
        lastDocuments[docTypeStatus] = doc;
      }
    }
  });

  return lastDocuments;
}

export const POLICY_INDEX = 3;

class UnitDetail extends Component<Props, State> {

  constructor(props: any) {
    super(props)
    this.state = {refresh: false}
  }

  componentWillUnmount() {
    document.body.classList.remove("unit-detail-background");
  }

  render() {
    if (!document.body.classList.contains("unit-detail-background")) {
      document.body.classList.add("unit-detail-background");
    }
    return (
      <UnitDetailContext.Consumer>
        { context => {
          const resetContext = () => context = {
            open: false,
            unit: null,
            documentTypes: [],
            unitType: null,
            refresh: null
          }

          const getUnit = function (domain: string) {
            if (domain)
              UnitsApi.get(domain)
              .then(it => {
                context.unit = it.data
                context.refresh()
              })
          }

          const getDocumentTypes = function () {
              DocumentTypesApi.filter()
              .then(it => {
                context.documentTypes = it.data
                context.refresh()
              })
          }

          context.refresh = () => this.setState({refresh: !this.state.refresh})

          if (!context.unit || !context.documentTypes.length) {
            if (!context.unit && !context.documentTypes.length) {
              getUnit(this.props.params!.domain)
              getDocumentTypes()
            }
            return (<Box></Box>)
          }

          const descargar = () => {
            if (context.unit && context.unit.documents) {
              const lastDocuments = getLastDocuments(context.unit);
              const documentsToDownload = Object.values(lastDocuments);

              if (documentsToDownload.length > 0) {
                documentsToDownload.forEach((doc: any) => {
                  const name = getDocumentName(doc, context.documentTypes, this.props.params!.domain);
                  fetch(`${HOST}/${doc.mediaURL}`)
                    .then(response => response.blob())
                    .then(blob => {
                      const file = new File([blob], name, { type: doc.fileContentType });
                      const link = document.createElement('a');
                      link.href = URL.createObjectURL(file);
                      link.download = name;
                      link.click();
                    });
                });
              } else {
                alert('No hay documentos');
              }
            } else {
              alert('No hay documentos');
            }
          }

          const handleConsul = () =>{
            if (!this.props.navigate) return
            this.props.navigate(`/web/consult-maintenance/${this.props.params!.domain}/${context.unit.id}`)
          }
          return (
            <Box>
              <ProfileHeader></ProfileHeader>
              <Box/>
              <Box sx={{maxWidth: '572px', margin: 'auto'}}>
                <Box className='unit-detail-title'><Trans i18nKey={`screens.unitDetail.title`}></Trans></Box>
                <MainSection isLogged={!!getSessionStorage(TOKEN_SO_KEY)}></MainSection>
                <DocumentIcons></DocumentIcons>
                <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                  <Button onClick={descargar}
                  className='unit-detail-button' sx={{marginTop: '20px'}}><Trans i18nKey={`screens.unitDetail.downloadDocumentation`}  ></Trans></Button>
                  {FULL_MENU =='true' && (
                  <Button className='unit-detail-button'  sx={{marginTop: '20px'}} onClick={handleConsul}><Trans i18nKey={`screens.unitDetail.requireMaintenance`}></Trans></Button>
                 
    )} 
    {/* <Button className='unit-detail-button' disabled={!getSessionStorage(TOKEN_SO_KEY)} sx={{marginTop: '20px'}}><Trans i18nKey={`screens.unitDetail.requireAssistance`}></Trans></Button> */}
                  {/* <Button className='unit-detail-button' disabled={!getSessionStorage(TOKEN_SO_KEY)} sx={{marginTop: '20px'}}><Trans i18nKey={`screens.unitDetail.exportTransactions`}></Trans></Button> */}
                </Box>
              </Box>
              <Box/>
              <PolicyDetailDialog/>
              { getSessionStorage(TOKEN_SO_KEY) !== null &&     <ProfileBottomNav goBack={true}></ProfileBottomNav>}
              {/* <Box className="bottom-nav">
                { getSessionStorage(TOKEN_SO_KEY) &&
                  <IconButton className="bottom-nav-text-icon">
                    <MenuIcon />
                  </IconButton>
                }
                { getSessionStorage(TOKEN_SO_KEY) &&
                  <Badge badgeContent={1} className="bottom-nav-text-icon" max={99}>
                    <Notifications />
                  </Badge>
                }
              </Box> */}
            </Box>
          )
        }}
      </UnitDetailContext.Consumer>
    );
  }

}

function withParams(Component: any) {
  return (props: Props) => <Component {...props} params={useParams()} navigate={useNavigate()} />;
}

export default withParams(UnitDetail);
